module.exports = __webpack_public_path__ + "img/s00168.dc256bae.png";